export const GET_ROAST_EVENTS = 'roasters/GET_ROAST_EVENTS';
export const GET_ROAST_EVENTS_SUCCESS = 'roasters/GET_ROAST_EVENTS_SUCCESS';
export const GET_ROAST_EVENTS_FAILED = 'roasters/GET_ROAST_EVENTS_FAILED';
export const ADD_ROAST_EVENTS = 'roasters/ADD_ROAST_EVENTS';
export const UPDATE_ROAST_EVENT = 'roasters/UPDATE_ROAST_EVENT';